/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 bird1_low_re.glb --transform --resolution --simplify -t -d
*/
import * as THREE from 'three'
import React, { createRef, useRef } from 'react'
import { meshBounds, useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import { useFrame, useThree } from '@react-three/fiber'
import state from '../../../utils/state'

type GLTFResult = GLTF & {
  nodes: {
    Model: THREE.Mesh
  }
  materials: {
    material0: THREE.MeshStandardMaterial
  }
}

export function Bird1Simpled(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('./models/low_re/transformed/bird1_low_re-transformed.glb') as GLTFResult

  const modelRef = createRef<any>()

  const stateThree = useThree()

  const pageLerp = useRef(state.top / stateThree.size.height)

  useFrame((s, delta) => {
    const page = (pageLerp.current = THREE.MathUtils.lerp(pageLerp.current, state.top / stateThree.size.height, delta * 6))

    if (!state.lowMode) {
      modelRef.current.visible = page >= 6.2 ? (page > 11.5 ? false : true) : false
    }
  })

  return (
    <group {...props} dispose={null}>
      <mesh ref={modelRef} geometry={nodes.Model.geometry} material={materials.material0} material-metalness={0.95} material-roughness={0.62} rotation={[1.69, 0.2, -0.15]} raycast={meshBounds}/>
    </group>
  )
}

useGLTF.preload('./models/low_re/transformed/bird1_low_re-transformed.glb')
